import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Table } from 'antd';
import { getMedicalCommissionsByUser } from '../../../../appRedux/actions';
import { stringDate, stringTime } from '../../../../util/formatTime';
import { UpdateCommissionMedical } from '../UpdateCommissionMedical';
import { roleConst } from '../../../../constants';
import { getFullName } from '../../../../util';
import { formatPrice } from '../../../../util/formatPrice';
import { TableFooterTotal } from '../../../uiComponents/TableFooterTotal/TableFooterTotal';

export const MedicalCommissionModalBody = ({ id, privileges, role }) => {
  const dispatch = useDispatch();
  const { medicalCommissionsByUser } = useSelector((state) => state.commission);
  const { filtersData } = useSelector((state) => state.generalStates);
  const [isUpdateComission, setIsUpdateComission] = useState(false);
  const [comissionId, setComissionId] = useState();

  const updateCommission = (data) => {
    setComissionId(data.id);
    setIsUpdateComission(true);
  };

  const handleUpdateComplete = () => {
    setIsUpdateComission(false);
  };

  useEffect(() => {
    dispatch(getMedicalCommissionsByUser(id, { params: filtersData }));
  }, [dispatch, id, filtersData]);

  const orders = useMemo(() => {
    const data = medicalCommissionsByUser?.orders;
    return Array.isArray(data) ? data : [];
  }, [medicalCommissionsByUser]);

  const totals = useMemo(() => {
    return (
      medicalCommissionsByUser?.totals ?? {
        sales: 0,
        grossCommission: 0,
        isr: 0,
        netCommission: 0,
      }
    );
  }, [medicalCommissionsByUser]);

  const renderUser = (user, data, privileges, updateCommission) =>
    privileges ? (
      <Button
        type="link"
        htmlType="button"
        onClick={() => updateCommission(data)}
      >
        {getFullName(user)}
      </Button>
    ) : (
      getFullName(user)
    );

  const columns = [
    {
      title: 'Número de cita',
      dataIndex: 'appointment',
      key: 'appointment',
      render: (appointment) => appointment?.appointmentNumber,
    },
    {
      title: 'Sucursal',
      dataIndex: 'appointment',
      key: 'branch',
      render: (appointment) => appointment?.branch?.name,
    },
    {
      title: 'Fecha',
      dataIndex: 'appointment',
      key: 'date',
      render: (appointment) => stringDate(appointment?.date),
    },
    {
      title: 'Hora',
      dataIndex: 'appointment',
      key: 'startTime',
      render: (appointment) => stringTime(appointment?.startTime),
    },
    {
      title: 'Cliente',
      dataIndex: 'appointment',
      key: 'customer',
      render: (appointment) => getFullName(appointment?.customer),
    },
    {
      title: 'Tratamiento',
      dataIndex: 'appointment',
      key: 'treatment',
      render: (appointment) => appointment?.treatment?.name,
    },
    {
      title: 'Comisión',
      dataIndex: 'commission',
      key: 'commission',
      render: (commission) => formatPrice(commission),
    },
    {
      title: 'ISR %',
      dataIndex: 'isr',
      key: 'isr',
      render: (isr) => `${isr.toFixed(2)}%`,
    },
  ];

  if (role !== roleConst.medic) {
    columns.splice(1, 0, {
      title: 'Médico',
      dataIndex: 'user',
      key: 'user',
      render: (user, data) =>
        renderUser(user, data, privileges, updateCommission),
    });
  }

  return (
    <>
      {isUpdateComission && (
        <UpdateCommissionMedical
          commissionId={comissionId}
          onUpdateComplete={handleUpdateComplete}
        />
      )}

      {!isUpdateComission && (
        <Table
          rowKey={(row) =>
            row?.id ??
            row?.appointment?.appointmentNumber ??
            `${row?.appointment?.appointmentNumber}-${row?.commission}`
          }
          dataSource={orders}
          columns={columns}
          pagination={{
            defaultPageSize: 5,
            pageSizeOptions: [5, 10, 15],
          }}
          summary={() => (
            <TableFooterTotal
              totals={[
                {
                  total: totals?.sales,
                  label: 'Total ventas',
                },
                {
                  total: totals?.grossCommission,
                  label: 'Comisión bruta',
                },
                {
                  total: totals?.isr,
                  label: 'ISR',
                },
                {
                  total: totals?.netCommission,
                  label: 'Comisión neta',
                },
              ]}
            />
          )}
        />
      )}
    </>
  );
};
